<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        :src="image"
        class="img-avatar"
        alt="Image" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-item><i class="fa fa-profile" /> Profile</b-dropdown-item>

        <b-dropdown-item @click="logout"><i class="fa fa-lock" />
          Logout
<!--          <router-link :to="{ name: 'Logout'}">Logout </router-link>-->
        </b-dropdown-item>

    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import {getService} from "../services";

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      image: "img/avatars/6.jpg",
    }
  },
  created: function () {
    this.getProfile()
  },
  methods: {
     getProfile() {
      getService.profile()
          .then(data => {
            this.$store.commit('changeBranch', data.data.BranchId)
            this.image = data.data.EmpPhotoUrl
          })
          .catch(() => {
              
          }) 
      },
      logout() {
         this.$router.push({name: 'Logout'})
      },
  }

}
</script>
